import { render, staticRenderFns } from "./ExchangeHome.vue?vue&type=template&id=4a716bda&scoped=true"
import script from "./ExchangeHome.vue?vue&type=script&lang=js"
export * from "./ExchangeHome.vue?vue&type=script&lang=js"
import style0 from "./ExchangeHome.vue?vue&type=style&index=0&id=4a716bda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a716bda",
  null
  
)

export default component.exports